module.exports = __webpack_public_path__ + "static/media/logo.6d5bd220.png";